import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as summaryReportAction from "../../../store/summary-report/action";

import { AvField, AvForm } from "availity-reactstrap-validation";
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Modal, Row, Table } from "reactstrap";
import {
    DELETE_RP_FUEL_CONSUMPTION,
    DELETE_RP_FUEL_CRITERIA,
    GET_RP_FUEL_CONSUMPTION,
    GET_RP_FUEL_CRITERIA,
    SAVE_LIST_FUEL_CONSUMPTION,
    SAVE_LIST_FUEL_CRITERIA,
    SAVE_RP_FUEL_CONSUMPTION,
    SAVE_RP_FUEL_CRITERIA,
    GET_DT_DAILY_FLOW_PLAN,
} from "helpers/url_api_constant";
import React, { useEffect, useMemo, useState } from "react";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import BarChart from "../SectionCompressorFuel/BarChart";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import debounce from "lodash.debounce";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";


function SectionCompressorFuel(props) {
    // console.log(props);
    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }
    const permission = getPermission();
    const dispatch = useDispatch();
    const searchDate = { SELECT_DATE: props.date };
    const [dailyTargetPlan, setDailyTargetPlan] = useState([]);
    const [dialogMagCriteria, setDialogMagCriteria] = useState(false);
    const [listManageCriteriaData, setListManageCriteriaData] = useState([]);
    const [dataGraphFlowPerFuel, setDataGraphFlowPerFuel] = useState([]);

    const [showValueCriteria, setShowValueCriteria] = useState({ SHOW_TEXT: "", VALUE_CRITERIA_TODAY: 0 });


    const modelConsumptionList = {
        SUMMARYREPORT_PID: props.summaryReportPid,
        ACCUM_ACTUAL: 0,
        ACCUM_END: "",
        ACCUM_START: "",
        ACCUM_TARGET: 0,
        CAUSE_REMARK: "",
        DAILY_FLOW: 0,
        FUEL_ACTUAL: 0,
        FUEL_DATE: "",
        FUEL_ELEC: 0,
        FUEL_GAS: 0,
        FUEL_TARGET: 0,
        FUEL_DIFF: 0,
        ACCUM_DIFF: 0,
        VALIDATE_FLAG: false,
    };

    const [rpFuelConsumptionListModel, setRPFuelConsumptionListModel] = useState(modelConsumptionList);


    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = "white";

        return style;
    };

    const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

    const SelectMagDateStartCriteria = (cellContent, row) => {
        return (
            <div>
                <Flatpickr
                    // value={this.state.defaultDate}
                    className="form-control d-block"
                    placeholder="Select Date"
                    options={{
                        altInput: true,
                        altFormat: "d/m/Y",
                        // altFormat: "F Y",
                        dateFormat: "d/m/Y",
                        // minDate: new Date(),
                        // maxDate: new Date(),
                    }}
                    onChange={(value) => {
                        // console.log(value);
                        setListManageCriteriaData(prevent => {
                            return prevent.map(obj => {
                                if (obj.ROW == row.ROW) {
                                    return { ...obj, START_DATE: moment(value[0]).format("YYYY-MM-DD"), TEMP_START_DATE: value[0], }
                                }

                                // ของเดิม
                                if (obj.ROW == row.ROW - 1) {
                                    return { ...obj, END_DATE: moment(value[0]).add("days", -1).format("YYYY-MM-DD") }
                                }
                                return { ...obj }
                            })
                        }
                        );
                    }}
                    value={row.TEMP_START_DATE}
                />
            </div>
        );
    };

    const SelectMagDateEndCriteria = (cellContent, row, rowIndex) => {
        return (
            <div>
                <span>{row.END_DATE ? moment(row.END_DATE).format("DD/MM/YYYY") : ""}</span>
                {/* <Flatpickr
                    // value={this.state.defaultDate}
                    className="form-control d-block"
                    placeholder="Select Date"
                    options={{
                        altInput: true,
                        altFormat: "d/m/Y",
                        // altFormat: "F Y",
                        dateFormat: "d/m/Y",
                        // minDate: new Date(),
                        // maxDate: new Date(),
                    }}
                    onChange={(value) => {
                        // console.log(value);
                        setListManageCriteriaData(prevent => {
                            return prevent.map(obj => {
                                if (obj.ROW == row.ROW) {
                                    return { ...obj, END_DATE: moment(value[0]).format("YYYY-MM-DD"), TEMP_END_DATE: value[0], }
                                }
                                // if (obj.ROW == row.ROW - 1) {
                                //     return { ...obj, END_DATE: moment(value[0]).add("days", -1).format("YYYY-MM-DD") }
                                // }
                                return { ...obj }
                            })
                        }
                        );
                    }}
                    value={row.TEMP_END_DATE}
                /> */}
            </div>
        );
    };

    const ButtonMagCriteria = (cellContent, row) => {
        // console.log(row);
        return (
            <div className="d-flex align-items-center justify-content-center">
                {(row.END_DATE != null && row.END_DATE != "") && (
                    <>
                        <OverButton
                            onClick={() => {
                                onMagCriteriaDelete(row);
                            }}
                            color="danger"
                            icon="fas fa-trash-alt"
                            label="Delete"
                        />
                    </>
                )}
            </div>
        );
    };

    const columnCriteria = [
        {
            dataField: "dummy",
            formatter: CountIndexRow,
            text: "No.",
            headerAlign: "center",
            sort: false,
            editable: false,
            align: "center",
            headerStyle: {
                width: "5%",
                fontSize: "14px",
            },
            style: {
                width: "5%",
            },
            type: "number",
        },
        {
            dataField: "COMPRESSOR_CRITERIA",
            text: "Criteria",
            headerAlign: "center",
            sort: false,
            editable: true,
            align: "center",
            headerStyle: {
                width: "15%",
                fontSize: "14px",
            },
            style: {
                width: "15%",
            },
            validator: (newValue, row, column, done) => {
                setTimeout(() => {
                    if (isNaN(newValue)) {
                        return done({
                            valid: false,
                            message: "Should be numeric",
                        });
                    }
                    return done();
                }, 0);
                return {
                    async: true,
                };
            },
        },
        {
            dataField: "START_DATE",
            text: "Start",
            headerAlign: "center",
            sort: false,
            editable: false,
            align: "center",
            headerStyle: {
                width: "15%",
                fontSize: "14px",
            },
            style: {
                width: "15%",
            },
            formatter: SelectMagDateStartCriteria,
        },
        {
            dataField: "END_DATE",
            text: "End",
            headerAlign: "center",
            sort: false,
            editable: false,
            align: "center",
            headerStyle: {
                width: "15%",
                fontSize: "14px",
            },
            style: {
                width: "15%",
            },
            formatter: SelectMagDateEndCriteria,
        },
        {
            dataField: "df1",
            text: "Action",
            isDummyField: true,
            editable: false,
            sort: false,
            formatter: ButtonMagCriteria,
            headerAlign: "center",
            align: "left",
            headerStyle: {
                width: "5%",
                fontSize: "14px",
            },
            style: {
                width: "5%",
            },
        },
    ];

    const defaultCriteriaSortColumn = [
        {
            dataField: "CREATE_DATE",
            order: "asc", // or desc
        },
    ];

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.CREATE_DATE < b.CREATE_DATE) {
            return -1;
        }
        if (a.CREATE_DATE > b.CREATE_DATE) {
            return 1;
        }
        return 0;
    }

    const openDialogCriteria = async () => {
        setDialogMagCriteria(true);
        reLoadDataCriteria();
    };
    const reLoadDataCriteria = async () => {
        setListManageCriteriaData([]);
        dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_RP_FUEL_CRITERIA, {});
            // console.log(res);
            setListManageCriteriaData(res.data.RPFuelCriteriaList.sort(compare).map((obj, index) => ({
                ...obj,
                ROW: index + 1,
                START_DATE: moment(obj.START_DATE).format("YYYY-MM-DD"),
                TEMP_START_DATE: moment(obj.START_DATE).toDate(),
                END_DATE: obj.END_DATE ? obj.END_DATE : "",
                // END_DATE: moment(obj.END_DATE).format("YYYY-MM-DD"),
                // TEMP_END_DATE: moment(obj.END_DATE).toDate(),
            })));
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
        // setListManageCriteriaData([]);
    };

    useEffect(function () {
        fetchData();
        // reLoadDataCriteria();
    }, [props.summaryReportPid]);

    const setDispatchAction = useMemo(
        () =>
            debounce((value) => {
                dispatch(
                    summaryReportAction.setFuelConsumptionToState({
                        ...value,
                        ACCUM_ACTUAL: value.ACCUM_ACTUAL,
                        ACCUM_END: value.ACCUM_END,
                        ACCUM_START: value.ACCUM_START,
                        ACCUM_TARGET: value.ACCUM_TARGET,
                        CAUSE_REMARK: value.CAUSE_REMARK,
                        DAILY_FLOW: value.DAILY_FLOW,
                        FUEL_ACTUAL: value.FUEL_ACTUAL,
                        FUEL_DATE: value.FUEL_DATE,
                        FUEL_ELEC: value.FUEL_ELEC,
                        FUEL_GAS: value.FUEL_GAS,
                        FUEL_TARGET: value.FUEL_TARGET,
                        FUEL_DIFF: value.FUEL_DIFF,
                        VALIDATE_FLAG: value.VALIDATE_FLAG,
                    })
                );
            }, 300),
        []
    );
    useEffect(() => {
        setDispatchAction(rpFuelConsumptionListModel);
    }, [rpFuelConsumptionListModel]);

    // useEffect(function () {
    //     dispatch(summaryReportAction.setFuelConsumptionToState({
    //         ...rpFuelConsumptionListModel,
    //         ACCUM_ACTUAL: rpFuelConsumptionListModel.ACCUM_ACTUAL,
    //         ACCUM_END: rpFuelConsumptionListModel.ACCUM_END,
    //         ACCUM_START: rpFuelConsumptionListModel.ACCUM_START,
    //         ACCUM_TARGET: rpFuelConsumptionListModel.ACCUM_TARGET,
    //         CAUSE_REMARK: rpFuelConsumptionListModel.CAUSE_REMARK,
    //         DAILY_FLOW: rpFuelConsumptionListModel.DAILY_FLOW,
    //         FUEL_ACTUAL: rpFuelConsumptionListModel.FUEL_ACTUAL,
    //         FUEL_DATE: rpFuelConsumptionListModel.FUEL_DATE,
    //         FUEL_ELEC: rpFuelConsumptionListModel.FUEL_ELEC,
    //         FUEL_GAS: rpFuelConsumptionListModel.FUEL_GAS,
    //         FUEL_TARGET: rpFuelConsumptionListModel.FUEL_TARGET,
    //         FUEL_DIFF: rpFuelConsumptionListModel.FUEL_DIFF,
    //         VALIDATE_FLAG: rpFuelConsumptionListModel.VALIDATE_FLAG,
    //     }));
    //     // console.log(qualityModel);
    // }, [rpFuelConsumptionListModel]);

    const fetchData = async () => {
        let dataRPFuel = {};
        let dataDialogCriteria = [];
        let calculate = 0;
        let flagValidate = false;
        dispatch(loadingAction.showLoading());
        try {
            let [resDataDialogCriteria, resRP, resGraph, resFuelTarget] = await Promise.all([
                post(GET_RP_FUEL_CRITERIA, {}),
                post(GET_RP_FUEL_CONSUMPTION, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" }),
                post(GET_RP_FUEL_CONSUMPTION, { REPORT_DATE: moment(props.date).format("YYYY-MM-DD") }),
                post(GET_DT_DAILY_FLOW_PLAN, { DAILYFLOWPLAN_PRE30_DATE: moment(props.date).format("YYYY-MM-DD") }),
            ]);

            dataDialogCriteria = resDataDialogCriteria.data.RPFuelCriteriaList;

            // console.log(dataDialogCriteria);

            if (resRP.data.RPFuelConsumptionList.length == 1) {
                dataRPFuel = resRP.data.RPFuelConsumptionList[0];
                calculate = (dataRPFuel.FUEL_ACTUAL - dataRPFuel.FUEL_TARGET).toFixed(2);
            } else {
                dataRPFuel = modelConsumptionList;
            };

            // console.log(resGraph);
            if (resGraph.resultCode == 200) {
                setDataGraphFlowPerFuel(resGraph.data.RPFuelConsumptionList.map(obj => ({
                    ...obj, SUM_FUEL: (obj.FUEL_ACTUAL - obj.FUEL_TARGET).toFixed(2)
                })));
            }

            // console.log(resFuelTarget);
            if (resFuelTarget.data != null) {
                setDailyTargetPlan(resFuelTarget.data.dtDailyFlowPlanList);
            } else {
                setDailyTargetPlan([]);
            }

            let dataRangeCriteria = dataDialogCriteria.find(item => {
                // console.log("start", moment(item.START_DATE).toDate(), "end", moment(item.END_DATE).toDate(), "fuel date", moment(data.FUEL_DATE).toDate());
                // console.log(moment(item.START_DATE).toDate() <= moment(data.FUEL_DATE).toDate() && item.END_DATE == null);
                if (moment(item.END_DATE).toDate() >= moment(dataRPFuel.FUEL_DATE).toDate() && moment(item.START_DATE).toDate() <= moment(dataRPFuel.FUEL_DATE).toDate()) {
                    return true;
                } else if (moment(item.START_DATE).toDate() <= moment(dataRPFuel.FUEL_DATE).toDate() && item.END_DATE == "" || item.END_DATE == null) {
                    return true;
                }
                return false;
            })
            // console.log(dataRangeCriteria);
            if (dataRangeCriteria != undefined && dataRangeCriteria != "" && dataRangeCriteria != null) {
                // console.log(dataRangeCriteria);
                setShowValueCriteria({
                    // SHOW_TEXT: "*บังคับต้องการกรอกค่า เมื่อ Target และ Actual รายวันแตกต่างกันเกิน " + dataRangeCriteria.COMPRESSOR_CRITERIA + " (สามารถปรับค่าได้)", ของเดิม
                    SHOW_TEXT: "-",
                    VALUE_CRITERIA_TODAY: dataRangeCriteria.COMPRESSOR_CRITERIA
                });

                if (calculate > dataRangeCriteria.COMPRESSOR_CRITERIA) {
                    // setRPFuelConsumptionListModel({ ...dataRPFuel, FUEL_DIFF: calculate, VALIDATE_FLAG: true })
                    flagValidate = true;
                }
            }

            setRPFuelConsumptionListModel({ ...dataRPFuel, FUEL_DIFF: calculate, VALIDATE_FLAG: flagValidate }) //Math.abs(calculate)
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    const handleCriteriaAddColumn = () => {
        setListManageCriteriaData(prevent => [
            ...prevent,
            {
                ROW: listManageCriteriaData.length + 1,
                PID: "",
                COMPRESSOR_CRITERIA: 0,
                START_DATE: "",
                END_DATE: "",
                TEMP_START_DATE: "",
                TEMP_END_DATE: "",
            },
        ]);
    };

    const handleSaveCriteria = async () => {
        dispatch(loadingAction.showLoading());
        try {
            if (
                !listManageCriteriaData.some(
                    row =>
                        row.COMPRESSOR_CRITERIA == ""
                )
            ) {
                let data = [...listManageCriteriaData];
                let res = await post(SAVE_LIST_FUEL_CRITERIA, data);
                // console.log(res);
                if (res.resultCode == 200) {
                    fetchData();
                    setDialogMagCriteria(false);
                    dispatch(messageAction.showMessage("Save success."));
                }
            } else {
                dispatch(messageAction.showMessage("Plesae key in."));
            }
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    const onMagCriteriaDelete = row => {
        dispatch(
            confirmAction.showConfirm(
                "Do you want to delete ?",
                () => {
                    deleteMagCriteria(row);
                }
            )
        );
    };

    const deleteMagCriteria = async (row) => {
        dispatch(loadingAction.showLoading());
        try {
            let res = await post(DELETE_RP_FUEL_CRITERIA, row);
            if (res.resultCode == 200) {
                dispatch(messageAction.showMessage("Delete Success."));
                reLoadDataCriteria();
            } else {
                dispatch(messageAction.showMessage(res.resultDescription));
            }
            dispatch(loadingAction.hideLoading());
        } catch (err) {
            dispatch(messageAction.showMessage(err.message));
            dispatch(loadingAction.hideLoading());
        }
    };

    return (
        <div>
            <Row>
                <Col sm="12">
                    <Card className="mb-1" style={{ backgroundColor: "#0087ff1a" }}>
                        <CardBody>
                            <Row>
                                <Col sm="12">

                                    <Row className="mt-0">
                                        <Col sm="12">
                                            <h5 className="mb-0 sm-0 font-size-18" style={{ color: "#46FCFF" }}> Compressor Fuel Consumption</h5>
                                        </Col>
                                    </Row>

                                    <Row className="mt-2">
                                        <hr style={{ color: "#46FCFF" }} />
                                    </Row>

                                    <Row>
                                        <FormGroup className="row">
                                            {/* <Label
                                                className="col-sm-1 col-form-label d-flex align-items-center justify-content-end"
                                                style={{ color: "#46FCFF" }}
                                            >
                                                Criteria
                                            </Label>
                                            <Col sm={3}>
                                                <Input
                                                    disabled={readonly}
                                                    type="text"
                                                    className="form-control basicborder"
                                                    onChange={(e) => setCreateModel(
                                                        {
                                                            ...createModel,
                                                            ALIAS_NAME: e.target.value
                                                        })
                                                    }
                                                    value={createModel.ALIAS_NAME}
                                                />
                                            </Col> */}
                                            <Col sm={3}>
                                                {permission.mMIM && (
                                                    <Button
                                                        onClick={() => openDialogCriteria()}
                                                        color="primary"
                                                        className="btn w-md ms-0"
                                                    // disabled={readonly == true}
                                                    >
                                                        <i className="fas fa-chart-line"> </i> &nbsp;&nbsp;&nbsp; Manage Criteria &nbsp;&nbsp;&nbsp;
                                                    </Button>
                                                )}
                                            </Col>
                                        </FormGroup>
                                    </Row>

                                    <Row className="mt-2">
                                        <Col lg="6">
                                            <div className="table-responsive">
                                                {/* hover-table-highlight */}

                                                <Table className="table table-bordered mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th colSpan={7} style={{ backgroundColor: "#556ee64a", color: "#46FCFF", textAlign: "center", width: "100%" }}>Compressor Fuel Consumption</th>
                                                        </tr>
                                                        <tr>
                                                            <th style={{ backgroundColor: "#556ee678", color: "#46FCFF", textAlign: "center", width: "20%" }}>Flow/Fuel (MMSCF/BBTU)</th>
                                                            <th style={{ backgroundColor: "#667eef85", color: "#46FCFF", textAlign: "center", width: "15%" }}>Target</th>
                                                            <th style={{ backgroundColor: "#5868b785", color: "#46FCFF", textAlign: "center", width: "15%" }}>Actual</th>
                                                            <th style={{ backgroundColor: "#667eef85", color: "#46FCFF", textAlign: "center", width: "15%" }}>Diff</th>
                                                            <th style={{ backgroundColor: "#5868b785", color: "#46FCFF", textAlign: "center", width: "35%" }}>Cause</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>

                                                        <tr>
                                                            <td>{moment(rpFuelConsumptionListModel.FUEL_DATE).locale('en').format("DD MMM YYYY")}</td>
                                                            <td>{numberFormat(rpFuelConsumptionListModel.FUEL_TARGET, 2)}</td>
                                                            <td>{numberFormat(rpFuelConsumptionListModel.FUEL_ACTUAL, 2)}</td>
                                                            <td style={{ color: Math.abs(rpFuelConsumptionListModel.FUEL_DIFF) > showValueCriteria.VALUE_CRITERIA_TODAY ? "#FF4545" : "#FFFFFF" }}>{numberFormat(rpFuelConsumptionListModel.FUEL_DIFF, 2)}</td>
                                                            <td rowSpan={2}>
                                                                <Col sm={12}>
                                                                    <Input
                                                                        placeholder={showValueCriteria.SHOW_TEXT}
                                                                        // placeholder="*บังคับต้องการกรอกค่า เมื่อ Target Actual รายวันแตกต่างกันเกิน"  {showValueCriteria}  "(สามารถปรับค่าได้)"
                                                                        type="textarea"
                                                                        rows="8"
                                                                        style={{ border: rpFuelConsumptionListModel.VALIDATE_FLAG != true ? "solid 1px #FFFFFF" : "solid 1px #FF4545", color: "#FFFFFF" }}  //FF3636
                                                                        className="form-control"
                                                                        onChange={(e) => setRPFuelConsumptionListModel(
                                                                            {
                                                                                ...rpFuelConsumptionListModel,
                                                                                CAUSE_REMARK: e.target.value
                                                                            })
                                                                        }
                                                                        value={rpFuelConsumptionListModel.CAUSE_REMARK}
                                                                    />
                                                                    <span className="mt-1 mb-1" style={{ color: "#FFFFFF", fontSize: "15px" }}>To day criteria : {numberFormat(showValueCriteria.VALUE_CRITERIA_TODAY, 0)}</span>

                                                                </Col>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Accumulate Year( {moment(rpFuelConsumptionListModel.ACCUM_START).locale('en').format("DD MMM YYYY")} - {moment(rpFuelConsumptionListModel.ACCUM_END).locale('en').format("DD MMM YYYY")})</td>
                                                            <td>{numberFormat(rpFuelConsumptionListModel.ACCUM_TARGET, 2)}</td>
                                                            <td>{numberFormat(rpFuelConsumptionListModel.ACCUM_ACTUAL, 2)}</td>
                                                            <td>{numberFormat(Math.abs(rpFuelConsumptionListModel.ACCUM_ACTUAL - rpFuelConsumptionListModel.ACCUM_TARGET), 2)}</td>
                                                            {/* แบบเช็ค ให้ขึ้นตัวอักษรสีแดง */}
                                                            {/* <td style={{ color: Math.abs(rpFuelConsumptionListModel.ACCUM_TARGET - rpFuelConsumptionListModel.ACCUM_ACTUAL) > showValueCriteria.VALUE_CRITERIA_TODAY ? "#FF2F21" : "#FFFFFF" }}
                                                            >{numberFormat(Math.abs(rpFuelConsumptionListModel.ACCUM_TARGET - rpFuelConsumptionListModel.ACCUM_ACTUAL), 2)}</td> */}
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>

                                            <div className="table-responsive mt-2">
                                                {/* hover-table-highlight */}
                                                <Table className="table table-bordered mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ backgroundColor: "#556ee678", color: "#46FCFF", textAlign: "center", width: "35%" }}>Daily Flow</th>
                                                            <th style={{ backgroundColor: "#667eef85", color: "#46FCFF", textAlign: "center", width: "35%" }}>Fuel (Gas)</th>
                                                            <th style={{ backgroundColor: "#5868b785", color: "#46FCFF", textAlign: "center", width: "30%" }}>Fuel (Elec.)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                                        <tr>
                                                            <td>{numberFormat(rpFuelConsumptionListModel.DAILY_FLOW, 2)}</td>
                                                            <td>{numberFormat(rpFuelConsumptionListModel.FUEL_GAS, 2)}</td>
                                                            <td>{numberFormat(rpFuelConsumptionListModel.FUEL_ELEC, 2)}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Col>

                                        <Col lg={6}>

                                            <CardTitle className="mb-2" style={{ color: "#46FCFF" }}>Flow per Fuel (of MMscf/BBTU)</CardTitle>

                                            <BarChart data={dataGraphFlowPerFuel} date={props.date} summaryReportPid={props.summaryReportPid} targetPlan={dailyTargetPlan} />

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row >

            {/*start : DialogCriteria */}
            <Modal size="xl" isOpen={dialogMagCriteria} backdrop={"static"} >
                <div className="modal-header" style={{ backgroundColor: "#0087ff1a" }}>
                    <h5 className="modal-title mt-0">
                        Criteria
                    </h5>
                </div>
                <div className="modal-body" style={{ backgroundColor: "#0087ff1a" }}>
                    <CardBody>
                        <BootstrapTable
                            id="dialog-criteria-table"
                            keyField="ROW"
                            data={listManageCriteriaData}
                            columns={columnCriteria}
                            rowStyle={rowStyleFontWhite}
                            wrapperClasses="table-on-scroll"
                            headerClasses="header-style"
                            defaultSorted={defaultCriteriaSortColumn}
                            cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                afterSaveCell: (oldValue, newValue, row, column) => {
                                    // console.log(columnDataList);
                                },
                            })}
                        />

                        <div className="text-center mt-2">
                            {permission.eSRT && (
                                <>
                                    <button
                                        type="submit"
                                        className="btn btn-primary me-2"
                                        onClick={() => handleCriteriaAddColumn()}
                                    >
                                        <i className="bx bx-plus"></i> Add
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() => handleSaveCriteria()}
                                    >
                                        <i className="bx bx-save"></i>&nbsp; Save
                                    </button>
                                </>
                            )}
                            <button
                                type="button"
                                className="btn btn-danger ms-2"
                                onClick={() => setDialogMagCriteria(false)}
                            >
                                <i className="fas fa-times"></i> Close
                            </button>
                        </div>

                    </CardBody>
                </div>
            </Modal >
            {/*end : DialogCriteria */}
        </div >

    )
}

SectionCompressorFuel.propTypes = {
    t: PropTypes.any,
    date: PropTypes.any,
    summaryReportPid: PropTypes.any,
}

export default SectionCompressorFuel
